import { configApiRef, fetchApiRef, useApi } from '@backstage/core-plugin-api';
import { useState, useCallback } from 'react';

type Response = {
  id: string;
  error_event_id: string;
  task_id: string;
  created_at: string;
};

export function useCreateErrorTrackingTask({ onError, onSuccess }: { onError?: () => void, onSuccess?: () => void }) {
  const [data, setData] = useState<Response | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const fetchApi = useApi(fetchApiRef);
  const configApi = useApi(configApiRef);
  const backendUrl = configApi.getString('backend.baseUrl');

  const execute = useCallback(async (body: {errorEventId: string, sev2TaskId: string}) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const response = await fetchApi.fetch(`${backendUrl}/api/uptime-monitor/proxy/error-tracking-tasks`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body)
      });

      if(!response.ok) {
        throw new Error("Failed to create error tracking task")
      }

      const result = await response.json()
      setData(result);
      onSuccess?.()
    } catch (error) {
      setIsError(true);
      onError?.()
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    data,
    isLoading,
    isError,
    execute,
  };
}
